import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import {
  action, flow, observable, makeObservable,
} from 'mobx';

import BaseStore from './BaseStore';
import MeetingsAPI from '../api/meetings';

class EditMeetingsStore extends BaseStore {
  isBusy = false;
  isMeetingInfoLoading = false;
  isUpdating = false;
  meetingSessions = {};
  errorText;
  selectedSlot;
  selectedKind;
  meetingInfo = {};
  isUpdated = false;
  errorMessage;

  getMeetingSessions = flow(function* (schoolId, minDate, maxDate) {
    this.isBusy = true;
    try {
      const { data } = yield MeetingsAPI.list(schoolId, minDate, maxDate);
      this.setMeetingSessions(data);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    } finally {
      this.isBusy = false;
    }
  });

  getMeetingInfo = flow(function* (meetingId) {
    this.isMeetingInfoLoading = true;
    try {
      const { data } = yield MeetingsAPI.getMeetingInfo(meetingId);
      this.meetingInfo = data;
      this.setSelectedSlot({
        start_date: data.scheduled_at,
      });
      this.setSelectedKind(data.kind);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    } finally {
      this.isMeetingInfoLoading = false;
    }
  });

  updateMeeting = flow(function* (meetingId) {
    this.isUpdating = true;
    try {
      yield MeetingsAPI.updateMeeting(meetingId, {
        scheduled_at: this.selectedSlot.start_date,
        kind: this.selectedKind,
      });
      this.isUpdated = true;
    } catch (error) {
      this.errorMessage = error?.response?.data?.errorMessages?.message || 'Une erreur est survenue, veuillez réessayer';
      // eslint-disable-next-line no-console
      console.log(error);
    } finally {
      this.isUpdating = false;
    }
  });

  cancelMeeting = flow(function* (meetingId) {
    this.isUpdating = true;
    try {
      yield MeetingsAPI.cancelMeeting(meetingId);
      this.isUpdated = true;
    } catch (error) {
      this.errorMessage = error?.response?.data?.errorMessages?.message || 'Une erreur est survenue, veuillez réessayer';
      // eslint-disable-next-line no-console
      console.log(error);
    } finally {
      this.isUpdating = false;
    }
  });

  constructor() {
    super();

    makeObservable(this, {
      isBusy: observable,
      isMeetingInfoLoading: observable,
      isUpdating: observable,
      meetingSessions: observable,
      errorText: observable,
      selectedSlot: observable,
      selectedKind: observable,
      meetingInfo: observable,
      isUpdated: observable,
      errorMessage: observable,
      setSelectedSlot: action.bound,
      setSelectedKind: action.bound,
      setMeetingSessions: action,
    });
  }

  setSelectedSlot(slot) {
    this.selectedSlot = slot;
  }

  setSelectedKind(kind) {
    this.selectedKind = kind;
  }

  setMeetingSessions = (data) => {
    let currentDate;

    const mapDataToSlotsFormat = map(data, (slot) => (
      {
        start_date: slot,
      }
    ));

    this.meetingSessions = groupBy(mapDataToSlotsFormat, (slot) => {
      [currentDate] = slot.start_date.split('T');

      return currentDate;
    });
  };
}

export default new EditMeetingsStore();
